<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="900px">
      <c-card class="white" :title="titleText">
      <div class="mt-2">
        <span class="red--text">*</span> 는 필수입력항목입니다.
      </div>
      <v-form lazy-validation ref="form">
        <v-row align="center">
          <v-col cols="12" md="3">
            <span class="font-weight-black">센터명 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="input.centerInfo.centerName"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-black">대표자 이름 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
                v-model="input.centerInfo.directorOfCenter"
                placeholder="이름을 입력해 주세요"
                hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-black">센터 주소 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-row class="ma-0 pa-0">
              <v-text-field
                id="centerAddr"
                v-model="input.centerInfo.centerAddress"
                placeholder="주소를 입력해주세요"
                @click="setAddress('center')"
                @keyup="setAddress('center')"
                hide-details
                maxlength="128"
              ></v-text-field>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-text-field
                v-model="input.centerInfo.centerAddressDetails"
                placeholder="상세 주소를 입력해주세요"
                hide-details
                maxlength="128"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="12" md="3">
            <span class="font-weight-black">차고지 주소 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-row class="ma-0 pa-0">
              <v-text-field
                v-model="input.centerInfo.garageAddress"
                placeholder="주소를 입력해주세요"
                hide-details
                @click="setAddress('garage')"
                @keyup="setAddress('garage')"
                maxlength="128"
              ></v-text-field>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-text-field
                v-model="input.centerInfo.garageAddressDetails"
                placeholder="상세 주소를 입력해주세요"
                hide-details
                maxlength="128"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="12" md="3">
            <span class="font-weight-black">센터 전화번호 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-row justify="space-around" align="center">
              <v-col cols="3" class="mr-0 pr-0">
                <v-text-field
                  v-model="input.mobileNo1"
                  solo
                  hide-details
                  required
                  dense
                  :autofocus="true"
                  v-mask="['##', '###']"
                  placeholder="051"
                  color="navy"></v-text-field>
              </v-col>
              <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
              <v-col cols="3" class="mx-0 px-0">
                <v-text-field
                  v-model="input.mobileNo2"
                  solo
                  hide-details
                  required
                  dense
                  :autofocus="true"
                  v-mask="['###', '####']"
                  placeholder="0000"
                  color="navy"></v-text-field>
              </v-col>
              <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
              <v-col cols="3" class="ml-0 pl-0">
                <v-text-field
                  v-model="input.mobileNo3"
                  solo
                  hide-details
                  required
                  dense
                  :autofocus="true"
                  v-mask="['####']"
                  placeholder="0000"
                  color="navy"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        
          <v-col cols="12" md="12">
            <span class="font-weight-black">문자 발송 <span class="red--text">*</span></span>
          </v-col>

          <v-col cols="12" md="3" style="margin-left: 30px;">
            <span class="font-weight-black">예약 완료 문자 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="3" style="margin-left: -30px;">
            <v-radio-group v-model="input.centerInfo.reservDoneAlert" row hide-details :disabled="!isSA">
              <v-radio label="활성" :value="true" ></v-radio>
              <v-radio label="비활성" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="5">
             <div>예약 완료 후 고객에게 안내 문자 발송</div>
          </v-col>
          <v-col cols="12" md="3" style="margin-left: 30px;">
            <span class="font-weight-black">출발 안내 문자<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="3" style="margin-left: -30px;">
            <v-radio-group v-model="input.centerInfo.remindAlert" row hide-details :disabled="!isSA">
              <v-radio label="활성" :value="true" ></v-radio>
              <v-radio label="비활성" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="5">
              출발
              <div style="width:80px;padding-right:5px;padding-left:10px;display:inline-block;text-align:right;">
                <v-text-field
                  v-model="input.centerInfo.smsSendReservationAlertBefore"
                  placeholder="0"
                  hide-details
                  justify-right
                  maxlength="8"
                  :disabled="!input.centerInfo.remindAlert || !isSA"
                ></v-text-field>
              </div>
              분 전 고객에게 안내 문자 발송
          </v-col>
          <v-col cols="12" md="3" style="margin-left: 30px;">
            <span class="font-weight-black">예약 취소 문자<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="3" style="margin-left: -30px;">
            <v-radio-group v-model="input.centerInfo.reservCanceledAlert" row hide-details :disabled="!isSA">
              <v-radio label="활성" :value="true" ></v-radio>
              <v-radio label="비활성" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="5">
             <div>예약 취소 후 고객에게 안내 문자 발송</div>
          </v-col>

          <v-col cols="12" md="3">
            <span class="font-weight-black">예약 푸시 발송 <span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="3" >
            <v-radio-group v-model="input.centerInfo.push" row hide-details :disabled="!isSA">
              <v-radio label="활성" value="Enable" ></v-radio>
              <v-radio label="비활성" value="Disable"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="6">
            <template  v-if="input.centerInfo.push === 'Enable'">
              출발
              <div style="width:80px;padding-right:5px;padding-left:10px;display:inline-block;text-align:right;">
                <v-text-field
                  v-model="input.centerInfo.pushSendReservationAlertBefore"
                  placeholder="0"
                  hide-details
                  justify-right
                  maxlength="8"
                ></v-text-field>
              </div>
              분 전 고객에게 안내 푸시 발송
            </template>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-black">서비스 이용<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-radio-group v-model="input.centerInfo.status" row hide-details :disabled="!isSA">
              <v-radio label="활성" value="Enable"></v-radio>
              <v-radio label="비활성" value="Disable"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-black">OBD 사용<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-radio-group v-model="input.centerInfo.obdAvailability" row hide-details :disabled="!isSA">
              <v-radio label="사용" :value="true"></v-radio>
              <v-radio label="미사용" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-black">주행 거리 입력<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-radio-group v-model="input.centerInfo.usingDriverRecordDistance" row hide-details :disabled="!isSA">
              <v-radio label="사용" :value="true"></v-radio>
              <v-radio label="미사용" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          
          <!-- 필수값인지? -->
          <!--<v-col cols="12" md="3">-->
            <!--<span class="font-weight-black">결제 방식<span class="red&#45;&#45;text">*</span></span>-->
          <!--</v-col>-->
          <!--<v-col cols="12" md="9">-->
            <!--<v-radio-group v-model="centerInfo.payMethod" row hide-details :rules="[v => !!v]">-->
              <!--<v-radio label="현장결제" value="cpm_site"></v-radio>-->
              <!--<v-radio label="바우처결제" value="cpm_voucher"></v-radio>-->
            <!--</v-radio-group>-->
          <!--</v-col>-->
          <v-col cols="12" md="3">
            <span class="font-weight-black">카드 결제 사용<span class="red--text">*</span></span>
          </v-col>
          <v-col cols="12" md="9">
            <v-radio-group v-model="input.centerInfo.usingCardPayment" :disabled="!isSA" row>
              <v-radio label="활성" :value="true"></v-radio>
              <v-radio label="비활성" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <template v-if="input.centerInfo.usingCardPayment">
            <v-col cols="12" md="3">
              <span class="font-weight-black">사업자등록번호</span>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-mask="maskRegistrationNumber"
                v-model="input.centerInfo.registrationNumber"
                hide-details
                placeholder="051-00-00000"
                maxLength="12"
                :disabled="!isSA"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-black">카드결제 가맹점MID</span>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="input.centerInfo.cardMemberMid"
                hide-details
                maxLength="10"
                :disabled="!isSA"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-black">카드결제 appId</span>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="input.centerInfo.cardAppId"
                hide-details
                maxLength="4"
                :disabled="!isSA"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <span class="font-weight-black">카드결제 상품이름</span>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="input.centerInfo.cardGoodName"
                hide-details
                maxLength="80"
                :disabled="!isSA"
              ></v-text-field>
            </v-col>
          </template>

          <v-row justify="center">
            <c-btn v-if="center" class="mr-1 mt-2" color="blue" outlined @click="onUpdateCenter">수정</c-btn>
            <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onAddCenter">등록</c-btn>
            <c-btn class="mt-2" color="gray" outlined @click="openFlag=false">취소</c-btn>
          </v-row>
        </v-row>
      </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mask } from 'vue-the-mask';


  export default {
    directives: { mask },

    props: {
      open: {
        type: Boolean,
        default: false,
      },
      center: {
        type: Object,
        default: undefined
      }
    },
    data() {
      return {
        default: {
          centerInfo:{
            service:this.$store.state.service,
            reservCanceledAlert: false,
            reservDoneAlert: false, 
            remindAlert: false,
            push:'Disable',
            status:'Enable',
            obdAvailability:false
          },
          mobileNo1: '',
          mobileNo2: '',
          mobileNo3: '',
        },
        oldValue: {

        },
        input: {
          centerInfo:{
            service:'',
            centerName:'',
            directorOfCenter: '',
            centerAddress:'',
            centerAddressDetails:'',
            centerPoint:'',
            garageAddress:'',
            garageAddressDetails:'',
            garagePoint:'',
            number:'',
            registrationNumber:'',
            reservDoneAlert: '',
            remindAlert: '',
            reservCanceledAlert: '',
            smsSendReservationAlertBefore:'',
            push:'',
            pushSendReservationAlertBefore:'',
            status:'',
            cardMemberMid:'',
            cardAppId:'',
            cardGoodName:'',
            obdAvailability:false,
            usingCardPayment:false,
            usingDriverRecordDistance:false,
          },
          mobileNo1: '',
          mobileNo2: '',
          mobileNo3: '',

        },

        mobileNoRegx: /^(01[016789]|02|0[3-9][0-9])-[0-9]{3,4}-[0-9]{4}$/,
        mask: '###-###-####',
        maskRegistrationNumber: "###-##-#####",
        openFlag: false,
      }
    },
    computed: {
      titleText() {
        return this.center ? '센터 정보 수정' : '센터 등록';
      },
      isSA(){
        return this.$store.state.userInfo.role === 'SA'
      },
      validateField() {
        if(this.input.centerInfo.remindAlert === false) {
          this.input.centerInfo.smsSendReservationAlertBefore = null;
        } else
        if(this.input.centerInfo.push === 'Disable') {
          this.input.centerInfo.pushSendReservationAlertBefore = null;
        }

        //필수항목 체크
        const isCenterName = this.input.centerInfo.centerName.length > 0;
        const isDirectorOfCenter = this.input.centerInfo.directorOfCenter.length > 0;
        
        const isCenterAddress = this.input.centerInfo.centerAddress.length > 0 && this.input.centerInfo.centerPoint.length > 0;
        const isCenterGarageAddress = this.input.centerInfo.garageAddress.length > 0 && this.input.centerInfo.garagePoint.length > 0;
        const isNumber = this.input.centerInfo.number.replace(/\-/g,"").length > 0;

        const isReservDoneAlert = this.input.centerInfo.reservDoneAlert !== '';
        const isReservCanceledAlert = this.input.centerInfo.reservCanceledAlert !== '';
        const isRemindAlert = this.input.centerInfo.remindAlert !== '';
        const isPush = this.input.centerInfo.push.length > 0;
        //const isPushTimer = isPush && this.input.centerInfo.push === 'Enable'? this.input.centerInfo.smsSendReservationAlertBefore.length > 0 : true;
        const isStatus = this.input.centerInfo.status.length > 0;
        
        let isUsingCardPayment = true
        let isRegistrationNumber = true
        if(this.input.centerInfo.usingCardPayment) {
          isRegistrationNumber = this.input.isExistRegistrationNumber ? this.input.isExistRegistrationNumber && this.input.centerInfo.registrationNumber.length > 0 : true;
          isUsingCardPayment = 
          this.input.centerInfo.registrationNumber && this.input.centerInfo.cardMemberMid && this.input.centerInfo.cardAppId && this.input.centerInfo.cardGoodName ? true : false
        }else {
          this.input.centerInfo.registrationNumber = ''
          this.input.centerInfo.cardMemberMid = ''
          this.input.centerInfo.cardAppId = ''
          this.input.centerInfo.cardGoodName = ''
        }
        // return (isCenterName && isRegistrationNumber && isCenterAddress && isCenterGarageAddress && isNumber && isSms && isSmsTimer && isPush && isPushTimer && isStatus)
        return (
          isCenterName && isDirectorOfCenter && isRegistrationNumber && 
          isCenterAddress && isCenterGarageAddress && isNumber && isReservDoneAlert && 
          isReservCanceledAlert && isRemindAlert && isPush && isStatus &&  isUsingCardPayment)
      }
    },
    watch: {
      open(newVal) {
        this.openFlag = newVal;
        if(this.center) {
          this.input.centerInfo = {...this.center};

          this.input.mobileNo1 = this.input.centerInfo.number.split('-')[0];
          this.input.mobileNo2 = this.input.centerInfo.number.split('-')[1];
          this.input.mobileNo3 = this.input.centerInfo.number.split('-')[2];
        } else {
          this.initInputData();
        }
      },
      openFlag(newVal) {
        this.$emit('update:open', newVal);
      },
      'input.isExistRegistrationNumber'(flag) {
        if (!flag) {
          this.input.centerInfo.registrationNumber = '';
        }
      }
    },
    methods: {
      initInputData() {
        this.input = this.$func.initObjectData(this.input, this.default);
        this.oldValue.obdAvailability = this.input.centerInfo.obdAvailability
        this.oldValue.usingDriverRecordDistance = this.input.centerInfo.usingDriverRecordDistance
        this.oldValue.usingCardPayment = this.input.centerInfo.usingCardPayment
      },
      setAddress(type){

        // 주소-좌표 변환 객체 생성
        const geocoder = new kakao.maps.services.Geocoder();

        new daum.Postcode({
          oncomplete: (data) => {
            // console.log('Postcode result', data);

            let addr = ''; // 주소 변수
            let extraAddr = ''; // 참고항목 변수
            let point = '';

            // 사용자가 도로명 주소를 선택했을 경우
            if (data.userSelectedType === 'R') {
              addr = data.roadAddress;

              if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                extraAddr += data.bname;
              }
              // 건물명이 있고, 공동주택일 경우 추가한다.
              if(data.buildingName !== '' && data.apartment === 'Y'){
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
              }
              // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
              if(extraAddr !== ''){
                extraAddr = ' (' + extraAddr + ')';
              }

              addr = addr + ' ' + extraAddr;

            } else { // 사용자가 지번 주소를 선택했을 경우(J)
              addr = data.jibunAddress;
            }

            //차고지인경우 좌표값이 필요하다.
            // 주소로 상세 정보를 검색
            geocoder.addressSearch(data.address, (results, status) => {
              // 정상적으로 검색이 완료됐으면
              if (status === daum.maps.services.Status.OK) {

                const result = results[0]; //첫번째 결과의 값을 활용
                point = Number(result.x).toFixed(6)+','+Number(result.y).toFixed(6);
              }
              if(type === 'center') {
                this.input.centerInfo.centerAddress = addr;
                this.input.centerInfo.centerPoint = point;
              } else if(type ==='garage') {
                this.input.centerInfo.garageAddress = addr;
                this.input.centerInfo.garagePoint = point;
              }
            });
          }
        }).open();
      },

      onAddCenter() {
        this.input.centerInfo.number = this.input.mobileNo1+'-'+this.input.mobileNo2+'-'+this.input.mobileNo3;
        if (this.validateField) {
          this.$emit('reqAddCenter', this.input.centerInfo);
        } else {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
        }

      },
      async onUpdateCenter() {
        this.input.centerInfo.number = this.input.mobileNo1+'-'+this.input.mobileNo2+'-'+this.input.mobileNo3;
        // this.centerInfo.centerPay = this.centerPayConfig.filter(item => item.configValue === this.centerInfo.payMethod)[0];

        if (this.validateField) {
          if(this.isSA) {
            const obdCheck = this.oldValue.obdAvailability === this.input.centerInfo.obdAvailability
            const usingDriverRecordDistanceCheck = this.oldValue.usingDriverRecordDistance === this.input.centerInfo.usingDriverRecordDistance
            const usingCardPaymentCheck = this.oldValue.usingCardPayment === this.input.centerInfo.usingCardPayment

            //3개에 값 중 변경 값이 있고 주행 중 건이 있으면 실패 처리
            if( !(obdCheck && usingDriverRecordDistanceCheck && usingCardPaymentCheck)){
              const count = await this.$api.getDriveStatusCount("DS_DRIVE")
              if(count > 0) {
                this.$store.commit('snackbar', {timeout : 2000 ,msg: '주행 중인 내역이 있어 수정이 불가합니다.'});
                return false
              }
            }
          }
        
          this.$emit('reqUpdateCenter', this.input.centerInfo);
        } else {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
        }        
      }
    }
  }
</script>

<style scoped>

</style>
